import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getMeeting } from 'actions/meetings';
import PostContent from 'components/Presentation/PostContent';
import SectionTitle from 'components/Presentation/SectionTitle';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Block, translate } from '@haldor/ui';
import { DataList, Spinner } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import DateTime from '_class/DateTime';
import { setPageTitle } from 'actions/header';
import { getActiveStudent } from 'helpers/guardian';
var Meeting = /*#__PURE__*/function (_Component) {
  function Meeting(props) {
    var _this;
    _classCallCheck(this, Meeting);
    _this = _callSuper(this, Meeting, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getMeeting(_this.props.activeStudent, _this.props.match.params.id).then(function () {
        _this.setState({
          loading: false
        });
        _this.props.setPageTitle(_this.props.meeting.title);
      });
    });
    _defineProperty(_this, "renderInstance", function (instance) {
      var activeStudent = getActiveStudent();
      if (instance.studentId != activeStudent) {
        return null;
      }
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement(RowItem, {
        key: instance.id,
        target: "/meetings/" + _this.props.meeting.id + "/instance/" + instance.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: translate('Name')
      }, instance.student.firstName + " " + instance.student.lastName), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('Follow up'),
        shrink: true
      }, instance.followUp ? translate('Required') : null), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('Start time'),
        shrink: true
      }, instance.date != null ? new DateTime(instance.date).getTimeStampHours() : ''), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('End time'),
        shrink: true
      }, instance.endDate != null ? new DateTime(instance.endDate).getTimeStampHours() : ''));
    });
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(Meeting, _Component);
  return _createClass(Meeting, [{
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Meeting information')), /*#__PURE__*/React.createElement(PostContent, null, this.props.meeting.description))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "section single-section"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate('Occasions'))), /*#__PURE__*/React.createElement(DataList, {
        data: this.props.meeting.instances,
        renderRow: this.renderInstance
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    meeting: state.Meetings.meeting,
    activeStudent: state.guardians.activeStudent,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getMeeting: getMeeting,
  setPageTitle: setPageTitle
})(Meeting);